import {
  Card,
  Heading,
  Link,
  ListItem,
  ListUnordered,
} from "@digdir/designsystemet-react";
import { ExternalLinkIcon } from "@navikt/aksel-icons";
import { Link as InternalLink } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils";

type LinkItem = {
  title: string;
  href: string;
  external?: boolean;
  hideFromFaq?: boolean;
};

export const NyttigeLenker = ({
  className,
  isFaqPage = false,
}: PropsWithChildren<{ className?: string; isFaqPage?: boolean }>) => {
  const { t } = useTranslation();

  const nyttigeLenker: LinkItem[] = [
    {
      title: t("eksterneLenker.forskriftOmNorgespris.label"),
      href: t("eksterneLenker.forskriftOmNorgespris.url"),
    },
    {
      title: t("eksterneLenker.lovOmNorgespris.label"),
      href: t("eksterneLenker.lovOmNorgespris.url"),
    },
    {
      title: t("eksterneLenker.kundestotte.label"),
      href: t("eksterneLenker.kundestotte.url"),
      hideFromFaq: true,
      external: false,
    },
    {
      title: t("eksterneLenker.avtalevilkaar-og-avbestilling.label"),
      href: t("eksterneLenker.avtalevilkaar-og-avbestilling.url"),
      external: false,
    },
  ].filter((link) => !(isFaqPage && link.hideFromFaq));
  return (
    <div className={cn(className)}>
      <Card className="space-y-4 lg:max-w-sm w-fit h-fit" variant="tinted">
        <Heading level={3} data-size="xs">
          {t("components.nyttige-lenker")}
        </Heading>
        <ListUnordered className="list-none pl-0 space-y-4">
          {nyttigeLenker.map((link) => (
            <ListItem key={link.href}>
              {link.external !== false ? (
                <Link
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="text-balder-text-default"
                >
                  {link.title}
                  <ExternalLinkIcon
                    fontSize={"1.5rem"}
                    className="pl-1"
                    aria-hidden
                  />
                </Link>
              ) : (
                <Link asChild>
                  <InternalLink to={link.href}>{link.title}</InternalLink>
                </Link>
              )}
            </ListItem>
          ))}
        </ListUnordered>
      </Card>
    </div>
  );
};
